import angular from 'angular';

class modalImportCtrl {
  /* @ngInject */
  constructor($translate, CONF, logger, PrincipalSvc) {
    this.$translate = $translate;
    this.CONF = CONF;
    this.logger = logger;
    this.PrincipalSvc = PrincipalSvc;
  }

  $onInit() {
    this.hasUpdate = false;
    this.includes = {
      errorMessages: require('../../layouts/error-messages.html')
    };
    this.principal = angular.copy(this.resolve.principal);
    this.type = angular.copy(this.resolve.type);

    // Init des données
    this.title = 'principal.' + this.type + '.import.title';
    this.text = 'principal.' + this.type + '.import.text';
    this.criteria = {};
    this.criteria.principalId = this.principal.detail.id;

    // Affichage des étapes de l'import
    this.displayForm = false;
    this.displayLoad = false;
    this.displayResult = false;

    this.manageDisplay('form');
  }

  importCsv() {
    if (this.form.$valid) {
      this.manageDisplay('load');
      this.PrincipalSvc.importRef(this.type, this.criteria).then(
        result => {
          if ('relations' === this.type ||'buyersrelations'=== this.type || 'sellers' === this.type || 'buyers' === this.type) {
            this.progressTitle = this.$translate.instant(this.title);
            this.displayProgress = true;
            this.taskId = result.data;
          } else {
            this.manageDisplay('result', this.type);
            this.report = result;
            this.hasUpdate = true;
          }
        },
        error => {
          if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
            this.logger.error('error.operation_already_inprogress');
            this.cancel();
          } else {
            this.criteria.file = null;
            this.logger.error('error.import');
            this.manageDisplay('form');
          }
        }
      );
    }
  }

  onTaskEnd(results) {
    this.displayProgress = false;
    if (results) {
      var report = results.result;
      this.PrincipalSvc.getReportWithLink(report, 'REFSOC', this.principal.detail.id);
      this.manageDisplay('result', this.type);
      this.report = report;
      this.hasUpdate = true;
    }
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  ok() {
    this.modalInstance.close(this.hasUpdate);
  }

  manageDisplay(step, type) {
    switch (step) {
      case 'form':
        this.displayForm = true;
        this.displayLoad = false;
        this.displayResult = false;
        break;
      case 'load':
        this.displayForm = false;
        this.displayLoad = true;
        this.displayResult = false;
        break;
      case 'result':
        this.title = 'principal.' + type + '.result.title';
        this.displayForm = false;
        this.displayLoad = false;
        this.displayResult = true;
        break;
    }
  }
}

angular.module('app.principal').component('modalImport', {
  templateUrl: require('./modal-import.html'),
  controller: modalImportCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
